/* This is ment to build provide a quick starting point when starting new index type file */
import React, {useState, useContext, useEffect} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';
import contactFormStyle from './style';
import emailAPI from '../../api/email/sendEmail';

export default function ContactForm({mt, texts, title, to, sucessMessage, addonStyle}) {
	let style = contactFormStyle();
	let user = useContext(GlobalContext).user;
	let emailServer = useContext(GlobalContext).emailServer;
	let userLoading = useContext(GlobalContext).userLoading;
	let [email, setEmail] = useState(getInitialEmail());
	let [message, setMessage] = useState(null);

	useEffect(async () => {
		setEmail(user ? user.email : null);
	}, [userLoading]);

	return (
		<div style={{...style.outerStyle({mt: mt}), ...addonStyle}}>
			{title ? <h1 className='nice-header text-center px-3 text-black'>{title}</h1> : <></>}
			{texts ? (
				texts.map((text, i) => {
					return (
						<p className='mt-3 px-3' key={i}>
							{text}
						</p>
					);
				})
			) : (
				<></>
			)}
			{user ? (
				<></>
			) : (
				<>
					<p className='mt-3 px-3'>Email</p>
					<input className='mt-3 px-3 mx-3' style={style.inputStyle()} onChange={emailChanged}></input>
				</>
			)}
			<p className='mt-3 px-3'>Message</p>
			<textarea style={style.inputStyle()} className='mt-3 px-3 mx-3' onChange={messageChanged} />
			<button style={style.buttonStyle()} className='mt-3 px-3 mx-3' onClick={sendEmail}>
				Submit
			</button>
		</div>
	);

	function emailChanged(e) {
		inputChanged(e, setEmail);
	}
	function messageChanged(e) {
		inputChanged(e, setMessage);
	}
	function inputChanged(event, seter) {
		let input = event.target.value;
		seter(input);
	}
	function emailPasses(email) {
		if (!email) return false;
		if (email.indexOf('@') < 0) return false;
		if (email.split('@')[1].length < 1) return false;
		return true;
	}
	function messagePasses(message) {
		if (!message || message.length < 1) {
			return false;
		} else if (message === '') {
			return false;
		}
		return true;
	}
	function sendEmail() {
		let finishMessage = sucessMessage;
		if (!emailPasses(email)) {
			alert(`${email} is not a valid email`);
		} else if (!messagePasses(message)) {
			alert('Please enter a valid message');
		} else {
			let newMessage = `A user (${email}) from theBRUGmethod.com has used your contact form\n${message}`;
			emailAPI
				.sendEmail(
					{
						to: 'anthonycavuoti@gmail.com',
						from: email,
					},
					{
						message: newMessage,
						subject: 'BRUG method contact form',
					},
					emailServer
				)
				.then(status => {
					if (status && !status.message && status.message !== 'sucessfull') {
						console.log('Email failed');
						finishMessage = 'Email failed';
					} else {
						console.log('Email was successfull');
					}
				})
				.catch(err => {
					console.error('Faild to send email');
					console.error(err);
					finishMessage = 'Email failed';
				})
				.finally(() => {
					alert(finishMessage);
				});
		}
	}
	function getInitialEmail() {
		if (user) {
			return user.email;
		}
		return null;
	}
}
